<template>
  <v-layout align-start>
    <v-flex xs12>
      <v-toolbar text color="white">
        <v-toolbar-title>Artículos</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class="brown lighten-1 mx-1" fab small dark @click.native="listar()">
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-btn class="green mx-1" fab small dark @click.native="exportarArticulosExcel()">
          <v-icon>mdi-file-excel-outline</v-icon>
        </v-btn>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="articulos"
        :items-per-page="50"
        sort-by="sku_cliente"
        :search="filtros.otros"
        item-key="_id"
        class="elevation-1"
        :footer-props="{
                            itemsPerPageOptions: [15,50,100,-1]
                        }"
      >
        <template v-slot:top>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs9 sm9 md9>
                <v-text-field
                  v-model="filtros.otros"
                  append-icon="search"
                  label="Sku o nombre"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs1 sm1 md1>
                <v-icon class="mt-2" @click="limpiarFiltros()" color="red">clear</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
        </template>
        <template v-slot:item.disponible="{ item }">
          <v-chip
            :color="getColorExistenciasDisponibles(item)"
            dark
          >{{ item.existencias - item.solicitado }}</v-chip>
        </template>
        <template v-slot:item.accion="{ item }">
          <v-icon small class="mr-2" @click="abrirMovimientos(item)">mdi-eye</v-icon>
        </template>
      </v-data-table>

      <v-dialog
        v-model="dialog_movimiento"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Movimientos de {{articulo.nombre}}</span>
          </v-card-title>
          <v-divider class="mx-2" inset horizonatal></v-divider>
          <v-card-text>
            <v-data-table
              :headers="headers_movimientos"
              :items="movimientos"
              :items-per-page="50"
              :search="filtros_movimientos.otros"
              item-key="_id"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs6 sm3 md3>
                      <v-dialog
                        ref="dialog_movimiento_filtro_fecha_inicio"
                        v-model="dialog_movimiento_filtro_fecha_inicio"
                        :return-value.sync="filtro_remoto_movimiento_fecha_inicio"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="filtro_remoto_movimiento_fecha_inicio_formateada"
                            label="Fecha inicio"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="filtro_remoto_movimiento_fecha_inicio"
                          :max="movimientos_fecha_inicio_maxima"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="dialog_movimiento_filtro_fecha_inicio = false"
                          >Cancelar</v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.dialog_movimiento_filtro_fecha_inicio.save(filtro_remoto_movimiento_fecha_inicio)"
                          >OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                    <v-flex xs6 sm3 md3>
                      <v-dialog
                        ref="dialog_movimiento_filtro_fecha_fin"
                        v-model="dialog_movimiento_filtro_fecha_fin"
                        :return-value.sync="filtro_remoto_movimiento_fecha_fin"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="filtro_remoto_movimiento_fecha_fin_formateada"
                            label="Fecha fin"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="filtro_remoto_movimiento_fecha_fin"
                          :min="movimientos_fecha_fin_minima"
                          :max="movimientos_fecha_fin_maxima"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="dialog_movimiento_filtro_fecha_fin = false"
                          >Cancelar</v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.dialog_movimiento_filtro_fecha_fin.save(filtro_remoto_movimiento_fecha_fin)"
                          >OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>

                    <v-flex xs11 sm5 md5>
                      <v-text-field
                        v-model="filtros_movimientos.otros"
                        append-icon="search"
                        label="Nombre usuario, email"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs1 sm1 md1>
                      <v-icon class="mt-2" @click="limpiarFiltrosMovimientos()" color="red">clear</v-icon>
                    </v-flex>
                  </v-layout>
                </v-container>
              </template>

              <template
                v-slot:item.creacion="{ item }"
              >{{formatearFecha(new Date(item.creacion).toISOString().substring(0, 10))}}</template>
              <template v-slot:item.estado_antes="{ item }">
                <v-icon
                  :color="getColorEstado(item.estado_antes)"
                  dark
                >{{getIconEstado(item.estado_antes)}}</v-icon>
              </template>
              <template v-slot:item.estado_despues="{ item }">
                <v-icon
                  :color="getColorEstado(item.estado_despues)"
                  dark
                >{{getIconEstado(item.estado_despues)}}</v-icon>
              </template>

              <!-- <template v-slot:item.accion="{ item }">
                <v-icon small class="mr-2" @click="editarMovimiento(item)">edit</v-icon>
              </template>-->
            </v-data-table>
            <v-flex xs12 sm12 md12 v-show="!!validaMensaje.length">
              <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v"></div>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" @click="cerrarDialogMovimiento">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
import XLSX from "xlsx";

export default {
  data() {
    return {
      dialog_movimiento: false,
      filtros: {
        otros: ""
      },
      dialog_movimiento_filtro_fecha_inicio: false,
      dialog_movimiento_filtro_fecha_fin: false,
      filtro_remoto_movimiento_fecha_inicio: null,
      filtro_remoto_movimiento_fecha_inicio_formateada: null,
      filtro_remoto_movimiento_fecha_fin: null,
      filtro_remoto_movimiento_fecha_fin_formateada: null,
      filtros_movimientos: {
        otros: ""
      },
      estados: {
        SOLICITADO: 1,
        SOLICITADO_SIN_STOCK: 2,
        PREPARANDO: 3,
        EMPAQUETADO: 4,
        EMBARCADO: 5,
        CANCELADO: 6,
        INCIDENCIA: 7
      },
      articulos: [],
      movimientos: [],
      headers: [
        { text: "Nombre", value: "nombre", sortable: true },
        { text: "Sku cliente", value: "sku_cliente", sortable: true },
        { text: "Disponible", value: "disponible", sortable: true },
        { text: "Existencias", value: "existencias", sortable: true },
        { text: "Solicitado", value: "solicitado", sortable: true },
        { text: "Mínimo", value: "minimo", sortable: true },
        { text: "Precio", value: "precio_neto", sortable: true },
        {
          text: "Acciones",
          value: "accion",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      headers_movimientos: [
        {
          text: "Fecha",
          value: "creacion",
          sortable: true,
          filterable: false
        },
        { text: "Rol usuario", value: "usuario.rol", sortable: false },
        { text: "Nombre usuario", value: "usuario.nombre", sortable: false },
        { text: "Email usuario", value: "usuario.email", sortable: false },
        {
          text: "Ref. Albarán",
          value: "albaran.cod_albaran",
          sortable: false
        },
        {
          text: "Ref. Picking",
          value: "picking_y_packing.ref_cliente",
          sortable: false
        },
        {
          text: "Antes",
          value: "estado_antes",
          sortable: false,
          filterable: false
        },
        {
          text: "Después",
          value: "estado_despues",
          sortable: false,
          filterable: false
        },
        {
          text: "Variación",
          value: "variacion",
          sortable: false,
          filterable: false
        },
        {
          text: "Existencias",
          value: "existencias",
          sortable: false,
          filterable: false
        }
        // {
        //   text: "Observaciones",
        //   value: "observaciones",
        //   sortable: false,
        //   filterable: false
        // },
        // {
        //   text: "Acciones",
        //   value: "accion",
        //   align: "center",
        //   sortable: false,
        //   filterable: false
        // }
      ],
      articulo: {
        _id: "",
        cod_cliente: "",
        sku_interno: "",
        sku_cliente: "",
        cod_barras: "",
        nombre: "",
        existencias: 0,
        solicitado: "",
        minimo: "",
        precio_neto: "",
        creacion: ""
      },
      validaMensaje: []
    };
  },
  computed: {
    movimientos_fecha_inicio_inicial() {
      let fecha = new Date();
      fecha.setDate(new Date().getDate() - 14);
      return fecha.toISOString().substring(0, 10);
    },
    movimientos_fecha_inicio_maxima() {
      let hoy = new Date();
      hoy.setDate(new Date().getDate());
      console.log("hoy", hoy.toISOString().substring(0, 10));
      console.log(
        "this.filtro_remoto_movimiento_fecha_fin",
        this.filtro_remoto_movimiento_fecha_fin
      );
      let fecha =
        hoy.toISOString().substring(0, 10) <
        this.filtro_remoto_movimiento_fecha_fin
          ? hoy.toISOString().substring(0, 10)
          : this.filtro_remoto_movimiento_fecha_fin;
      console.log("movimientos_fecha_inicio_maxima", fecha);
      return fecha;
    },
    movimientos_fecha_fin_minima() {
      return this.filtro_remoto_movimiento_fecha_inicio;
    },
    movimientos_fecha_fin_maxima() {
      let fecha = new Date();
      fecha.setDate(new Date().getDate());
      return fecha.toISOString().substring(0, 10);
    }
  },
  watch: {
    dialog_movimiento(val) {
      val || this.cerrarDialogMovimiento();
    },
    filtro_remoto_movimiento_fecha_inicio(val) {
      console.log("filtro_remoto_movimiento_fecha_inicio", val);
      this.filtro_remoto_movimiento_fecha_inicio_formateada = this.formatearFecha(
        val
      );
      console.log(
        "filtro_remoto_movimiento_fecha_inicio_formateada",
        this.filtro_remoto_movimiento_fecha_inicio_formateada
      );
      this.listarMovimientos();
    },
    filtro_remoto_movimiento_fecha_fin(val) {
      console.log("filtro_remoto_movimiento_fecha_inicio", val);
      this.filtro_remoto_movimiento_fecha_fin_formateada = this.formatearFecha(
        val
      );
      console.log(
        "filtro_remoto_movimiento_fecha_fin_formateada",
        this.filtro_remoto_movimiento_fecha_fin_formateada
      );
      this.listarMovimientos();
    },
    validaMensaje(val) {
      console.log("watch validaMensaje", val);
      if (val.length > 0) {
        this.$alert(val[0]);
      }
    }
  },
  created() {
    this.listar();
  },
  methods: {
    formatearFecha(date) {
      if (!date) {
        return null;
      }
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    getColorExistenciasDisponibles(articulo) {
      if (articulo.existencias - articulo.solicitado > articulo.minimo) {
        return "green";
      } else if (articulo.existencias - articulo.solicitado > 0) {
        return "orange";
      } else {
        return "red";
      }
    },
    limpiarFiltros() {
      console.log("limpiarFiltros");
      this.filtros.otros = "";
    },
    listar() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("articulo/list", configuracion)
        .then(function(response) {
          me.validaMensaje = [];
          me.articulos = response.data;
          console.log("me.articulos", me.articulos);
        })
        .catch(function(error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    limpiar() {
      this.validaMensaje = [];
    },
    exportarArticulosExcel() {
      console.log("exportarArticulosExcel");
      try {
        let articulos = [];
        this.articulos.forEach(a => {
          articulos.push({
            Sku: a.sku_cliente,
            "Código barras": a.cod_barras,
            Nombre: a.nombre,
            Disponible: a.existencias - a.solicitado,
            Existencias: a.existencias,
            Solicitado: a.solicitado,
            Mínimo: a.minimo,
            "Precio neto": a.precio_neto
          });
        });
        let worksheet = XLSX.utils.json_to_sheet(articulos);
        let new_workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(new_workbook, worksheet, "articulos");
        XLSX.writeFile(new_workbook, "articulos.xlsx");
      } catch (error) {
        console.error("export error", error);
      }
    },
    getIconEstado(estado) {
      switch (estado) {
        case this.estados.SOLICITADO:
          return "mdi-clipboard-list-outline";
        case this.estados.SOLICITADO_SIN_STOCK:
          return "mdi-clipboard-alert-outline";
        case this.estados.PREPARANDO:
          return "mdi-dropbox";
        case this.estados.EMPAQUETADO:
          return "mdi-package-variant-closed";
        case this.estados.EMBARCADO:
          return "mdi-truck";
        case this.estados.CANCELADO:
          return "mdi-file-cancel-outline";
        case this.estados.INCIDENCIA:
          return "mdi-alert";
      }
    },
    getColorEstado(estado) {
      switch (estado) {
        case this.estados.SOLICITADO:
          return "blue";
        case this.estados.SOLICITADO_SIN_STOCK:
          return "blue";
        case this.estados.PREPARANDO:
          return "purple";
        case this.estados.EMPAQUETADO:
          return "orange";
        case this.estados.EMBARCADO:
          return "green";
        case this.estados.CANCELADO:
          return "red";
        case this.estados.INCIDENCIA:
          return "#dcca28";
      }
      return "white";
    },
    abrirMovimientos(item) {
      console.log("abrirMovimientos articulo", item);
      this.articulo = Object.assign({}, item);
      this.filtro_remoto_movimiento_fecha_inicio = this.movimientos_fecha_inicio_inicial;
      this.filtro_remoto_movimiento_fecha_fin = this.movimientos_fecha_fin_maxima;
      console.log(
        "this.filtro_remoto_movimiento_fecha_inicio",
        this.filtro_remoto_movimiento_fecha_inicio
      );
      console.log(
        "this.filtro_remoto_movimiento_fecha_fin",
        this.filtro_remoto_movimiento_fecha_fin
      );
      this.listarMovimientos();
      this.dialog_movimiento = true;
    },
    listarMovimientos() {
      console.log("listarMovimientos");
      let me = this;
      let header = { Token: this.$store.state.token };
      let params = {
        fecha_inicio: this.filtro_remoto_movimiento_fecha_inicio,
        fecha_fin: this.filtro_remoto_movimiento_fecha_fin,
        _id_articulo: this.articulo._id
      };
      let configuracion = { headers: header, params: params };
      axios
        .get("movimiento_existencias/list", configuracion)
        .then(function(response) {
          me.validaMensaje = [];
          me.movimientos = response.data;
          console.log("me.movimientos", me.movimientos);
        })
        .catch(function(error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    exportarMovimientosExcel() {
      console.log("exportarMovimientosExcel");
      console.log(
        "this.filtros_articulos.codigo_cliente",
        this.filtros_articulos.codigo_cliente
      );
      try {
        let movimientos = [];
        this.movimientos.forEach(m => {
          console.log("m", m);
          movimientos.push({
            Fecha: formatearFecha(
              new Date(m.creacion).toISOString().substring(0, 10)
            ),
            "Ref. Albarán": m.albaran ? m.albaran.cod_albaran : "",
            "Ref. Picking": m.picking_y_packing
              ? m.picking_y_packing.ref_cliente
              : "",
            "Estado Previo": m.estado_antes,
            "Estado Después": m.estado_despues,
            Variación: m.variacion,
            Existencias: m.existencias
          });
        });
        let worksheet = XLSX.utils.json_to_sheet(movimientos);
        let new_workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(new_workbook, worksheet, "movimientos");
        XLSX.writeFile(new_workbook, "movimientos.xlsx");
      } catch (error) {
        console.error("export error", error);
      }
    },
    cerrar() {
      this.limpiar();
    },
    cerrarDialogMovimiento() {
      this.dialog_movimiento = false;
    }
  }
};
</script>

<style scoped>
.v-text-field {
  padding-top: 0px;
}
</style>
